import React from 'react'
import { connect } from 'react-redux'
import { Page } from '../../../components/page/Page'
import { DefaultFormToolBar } from '../../../components/toolbar/DefaultFormToolBar'
import { routes } from '../../../constants'
import { actions } from '../webhookPixAutomatico.actions'
import { WebhookPixAutomaticoForm } from './WebhookPixAutomaticoForm'
import utils from '../../../utils'
import storage from '../../../services/stoage.service'
import _ from 'lodash'
import { logarAcesso } from '../../../services/api-log-acesso'
import { Toast } from 'primereact/toast'

const mapStateToProps = (state) => {
  let unidades = utils.getListIdValuesUnidadeFromEmpresa(storage.getCompany())

  return {
    record: state.crudWebhookPixAutomaticoState.currentRecord,
    messages: state.crudWebhookPixAutomaticoState.messages,
    loadingCadastrar: state.crudWebhookPixAutomaticoState.loadingCadastrar,
    loadingConsultar: state.crudWebhookPixAutomaticoState.loadingConsultar,
    loadingCancelar: state.crudWebhookPixAutomaticoState.loadingCancelar,
    pspResponse: state.crudWebhookPixAutomaticoState.pspResponse,
    unidades,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setField: (field, value) => dispatch(actions.setField(field, value)),
    reset: () => dispatch(actions.reset()),
    saveHandler: (event) => {
      dispatch(actions.save())
    },
    removeHandler: (event) => {
      dispatch(actions.remove())
    },
    newHandler: (event) => {
      dispatch(actions.makeNew())
    },
    loadById: (oid) => dispatch(actions.loadById(oid)),
    cadastrarNoPsp: (oid) => dispatch(actions.cadastrarNoPsp(oid)),
    consultarNoPsp: (oid) => dispatch(actions.consultarNoPsp(oid)),
    cancelarNoPsp: (oid) => dispatch(actions.cancelarNoPsp(oid)),
    clearPspResponse: () => dispatch(actions.setPspResponse(null)),
  }
}

class WebhookPixAutomaticoFormPageContainer extends React.Component {
  constructor(props) {
    super(props)
    this.toast = React.createRef()
    this.state = {
      showDialogRemove: false,
      descricaoChanged: false,
    }

    actions.afterSave = ({ oid }) => {
      this.props.history.replace(`${routes.PATH_WEBHOOK_PIX_AUTOMATICO}/${oid}`)
    }
    actions.afterNew = () => {
      this.props.history.push(`${routes.PATH_WEBHOOK_PIX_AUTOMATICO}/novo`)
      this.props.reset()
    }
    actions.afterRemove = () => {
      this.props.history.replace(`${routes.PATH_WEBHOOK_PIX_AUTOMATICO}`)
    }

    actions.beforeFetchRecordSuccess = (data) => {
      return data
    }
  }

  componentDidMount() {
    const oidEntity = _.get(this, 'props.match.params.id', null)
    logarAcesso(oidEntity).then()
    if (oidEntity && parseInt(oidEntity)) {
      this.props.loadById(oidEntity)
      this.setState({ descricaoChanged: true })
    } else {
      this.props.newHandler()
    }
  }

  searchHandler = () => {
    this.props.history.push(`${routes.PATH_WEBHOOK_PIX_AUTOMATICO}`)
  }

  hideDialog = () => {
    this.setState({ showDialogRemove: false })
  }

  onChangeDescricao = (e) => {
    this.props.setField('descricao', e)
    this.setState({ descricaoChanged: true })
  }

  onChangeField = (fieldName, e) => {
    const field = _.get(e, 'target.name', null)
    if (field === 'ativo') {
      this.props.setField(field, _.get(e, 'target.checked', null))
      return
    }
    this.props.setField(fieldName, e)
  }

  onChangeTipo = (e) => {
    this.props.setField('tipo', e.value)
  }

  setConfiguracaoPixAutomatico = (data) => {
    const oid = _.get(data, 'oid', null)
    const nome = _.get(data, 'nome', '')

    this.props.setField('configuracaoPixAutomatico.id', oid)
    this.props.setField('configuracaoPixAutomatico.value', nome)
  }

  onCadastrarNoPsp = () => {
    const oid = this.props.record.oid
    if (oid) {
      this.props.cadastrarNoPsp(oid)
    }
  }

  onConsultarNoPsp = () => {
    const oid = this.props.record.oid
    if (oid) {
      this.props.consultarNoPsp(oid)
    }
  }

  onCancelarNoPsp = () => {
    const oid = this.props.record.oid
    if (oid) {
      this.props.cancelarNoPsp(oid)
    }
  }

  copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      this.toast.current.show({
        severity: 'success',
        summary: 'Sucesso',
        detail: 'URL copiada para a área de transferência',
        life: 3000,
      })
    })
  }

  buildHeader = () => {
    return <DefaultFormToolBar formPageContainer={this} />
  }

  render() {
    const content = (
      <>
        <Toast ref={this.toast} />
        <WebhookPixAutomaticoForm
          record={this.props.record}
          messages={this.props.messages}
          loadingCadastrar={this.props.loadingCadastrar}
          loadingConsultar={this.props.loadingConsultar}
          loadingCancelar={this.props.loadingCancelar}
          pspResponse={this.props.pspResponse}
          onChangeDescricao={this.onChangeDescricao}
          onChangeField={this.onChangeField}
          onChangeTipo={this.onChangeTipo}
          setConfiguracaoPixAutomatico={this.setConfiguracaoPixAutomatico}
          onCadastrarNoPsp={this.onCadastrarNoPsp}
          onConsultarNoPsp={this.onConsultarNoPsp}
          onCancelarNoPsp={this.onCancelarNoPsp}
          copyToClipboard={this.copyToClipboard}
        />
      </>
    )

    return <Page header={this.buildHeader()} content={content} />
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(WebhookPixAutomaticoFormPageContainer)
